var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconPictureComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Picture ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: useCurrentColor ? 'currentColor' : '#1BC0E4',
    d: "M0 0H36V36H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: useCurrentColor ? 'currentColor' : '#1BC0E4'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2981 13.2715C11.2981 12.7202 11.745 12.2732 12.2963 12.2732C12.8477 12.2732 13.2946 12.7202 13.2946 13.2715C13.2946 13.8228 12.8477 14.2697 12.2963 14.2697C11.745 14.2697 11.2981 13.8228 11.2981 13.2715ZM12.2963 9.27322C10.0882 9.27322 8.29808 11.0633 8.29808 13.2715C8.29808 15.4797 10.0882 17.2697 12.2963 17.2697C14.5045 17.2697 16.2946 15.4797 16.2946 13.2715C16.2946 11.0633 14.5045 9.27322 12.2963 9.27322ZM25.4024 17.3471L24.4199 15.8225L22.9621 16.9016L17.7086 20.7901L16.3327 19.3245L15.2909 18.2148L14.0732 19.1281L8.15308 23.5682L10.1931 26.2882L14.8956 22.7613L16.2649 24.2199L17.3 25.3225L18.5157 24.4227L23.5271 20.7135L27.0292 26.1477L29.8871 24.3059L25.4024 17.3471Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconPicture = /*#__PURE__*/React.forwardRef(IconPictureComponent);
export default IconPicture;